import { lazy } from 'react';
import DeviceApproval from '../pages/Device/DeviceApproval';
import {
  LIST_EDIT_DELETE_ROLES,
  MASTER_UNLOAD_ROLES,
} from '../constants/purchaseRoles';

const Home = lazy(() => import('../pages/Dashboard/Home'));
const Unloading = lazy(() => import('../pages/Unloading/Unloading'));
const VehicleLoading = lazy(
  () => import('../pages/VehicleLoading/VehicleLoading'),
);
const GateEntryForm = lazy(() => import('../components/unload/GateEntryForm'));
const PurchaseBillEntries = lazy(
  () => import('../components/unload/PurchaseBillEntries'),
);
const AddBillEntryForm = lazy(
  () => import('../components/unload/AddBillEntryForm'),
);
const GateEntryListing = lazy(
  () => import('../pages/Unloading/GateEntryListing'),
);
const PDApprovalListing = lazy(
  () => import('../pages/Unloading/PDApprovalListing'),
);
const PDApprovalForm = lazy(
  () => import('../components/unload/PDApprovalForm'),
);
const UnloadComplation = lazy(
  () => import('../pages/Unloading/UnloadCompletion'),
);
const UnloadComplationForm = lazy(
  () => import('../components/unload/UnloadCompletionForm'),
);
const LabMenu = lazy(() => import('../pages/Labwork/LabMenu'));

const UnloadingVehicleListing = lazy(
  () => import('../pages/Labwork/UnloadingVehicleListing'),
);
const LoadingVehiclesListing = lazy(
  () => import('../pages/Labwork/LoadingVehiclesListing'),
);
const LabProcess = lazy(() => import('../components/lab-work/LabProcess'));
const UnloadExitListing = lazy(
  () => import('../pages/Unloading/UnloadExitListing'),
);
const UnloadGateExitForm = lazy(
  () => import('../components/unload/UnloadGateExitForm'),
);
const UnloadDataEntries = lazy(
  () => import('../pages/Unloading/UnloadDataEntries'),
);
const MasterUnloadListing = lazy(
  () => import('../pages/Unloading/MasterUnloadListing'),
);
const MasterUnloadForm = lazy(
  () => import('../components/unload/MasterUnloadForm'),
);
const UnloadSingleData = lazy(
  () => import('../components/unload/UnloadSingleData'),
);
const DoAnOrder = lazy(() => import('../components/load/DoAnOrder'));

const DoAnOrderEntries = lazy(
  () => import('../pages/VehicleLoading/DoAnOrderEntries'),
);

const ProductListing = lazy(() => import('../pages/Product/ProductListing'));
const LabTestingListing = lazy(
  () => import('../pages/Labwork/LabTestingListing'),
);
const SingleLabTest = lazy(() => import('../pages/Labwork/SingleLabTest'));
const ApproveMaterialLoadListing = lazy(
  () => import('../pages/VehicleLoading/ApproveMaterialListing'),
);
const ApproveForm = lazy(() => import('../components/load/ApprovalForm'));
const LoadingCompletion = lazy(
  () => import('../pages/VehicleLoading/LoadingCompletion'),
);
const CompletionForm = lazy(() => import('../components/load/CompletionForm'));
const CustomerDetailListing = lazy(
  () => import('../pages/VehicleLoading/CustomerDetailListing'),
);
const CustomerDetailForm = lazy(
  () => import('../components/load/CustomerDetailForm'),
);
const GateExitListing = lazy(
  () => import('../pages/VehicleLoading/GateExitListing'),
);
const ExitPassForm = lazy(() => import('../components/load/ExitPassForm'));
const VehicleLoadingLisitng = lazy(
  () => import('../pages/VehicleLoading/VehicleLoadingLisitng'),
);
const LoadSingleData = lazy(() => import('../components/load/LoadSingleData'));
const MasterLoadListing = lazy(
  () => import('../pages/VehicleLoading/MasterLoadListing'),
);
const MasterLoadForm = lazy(() => import('../components/load/MasterLoadForm'));
const ConcernListing = lazy(() => import('../pages/Unloading/ConcernListing'));
const ApproveMenu = lazy(() => import('../pages/Approve/ApproveMenu'));
const UnloadCardMenu = lazy(
  () => import('../components/unload/UnloadCardMenu'),
);
const LoadCardMenu = lazy(() => import('../components/load/LoadCardMenu'));

const UnloadApprovalListing = lazy(
  () => import('../pages/Unloading/UnloadApprovalListing'),
);
const PurchaseDeptMenu = lazy(() => import('../pages/PurchaseDepartment/Menu'));
const UpcomingUnload = lazy(
  () => import('../pages/PurchaseDepartment/UpcomingUnload'),
);
const AddUpcomingUnload = lazy(
  () => import('../pages/PurchaseDepartment/AddUpcomingUnload'),
);
const UpcomingUnloadDetail = lazy(
  () => import('../pages/PurchaseDepartment/UpcomingUnloadDetail'),
);

const BvnMenu = lazy(() => import('../pages/BvnDept/Menu'));
const AllSale = lazy(() => import('../pages/BvnDept/AllSale'));
const AllPurchase = lazy(() => import('../pages/BvnDept/AllPurchase'));
const LabSamples = lazy(() => import('../pages/Labwork/LabSamples'));
const LabSampleForm = lazy(
  () => import('../components/lab-work/LabSampleForm'),
);
const SampleMenu = lazy(() => import('../pages/Sample/SampleMenu'));
const SampleListing = lazy(() => import('../pages/Sample/SampleListing'));
const CourierListing = lazy(() => import('../pages/Sample/CourierListing'));
const SampleForm = lazy(() => import('../components/Sample/SampleForm'));
const SampleDetail = lazy(() => import('../pages/Sample/SampleDetail'));
const CourierDetail = lazy(() => import('../pages/Sample/CourierDetail'));
const CourierAddForm = lazy(
  () => import('../components/Sample/CourierAddForm'),
);
const CourierUpdateForm = lazy(
  () => import('../components/Sample/CourierUpdateForm'),
);
const UserListing = lazy(() => import('../pages/Users/UserListing'));
const TransporterListing = lazy(
  () => import('../pages/Transporters/TransporterListing'),
);
const VehicleNumberListing = lazy(
  () => import('../pages/VehicleNumbers/VehicleNumberListing'),
);
const TransportListing = lazy(
  () => import('../pages/PurchaseDepartment/TransportListing'),
);
const TransportForm = lazy(
  () => import('../pages/PurchaseDepartment/TransportForm'),
);
const UnloadReport = lazy(() => import('../pages/BvnDept/UnloadReport'));
const Report = lazy(() => import('../pages/Approve/Report'));
const BillList = lazy(() => import('../components/load/SaleOrderList'));
const DoAnOrderDirectSale = lazy(
  () => import('../components/load/DoAnOrderDirectSale'),
);
const ToGenerate = lazy(() => import('../pages/BvnDept/ToGenerate'));
const AddBillingDetail = lazy(
  () => import('../components/load/AddBillingDetail'),
);
const BmrBillListing = lazy(() => import('../pages/BvnDept/BmrBillListing'));
const BvnNotifications = lazy(() => import('../pages/BvnDept/Notifications'));
const DevicePending = lazy(() => import('../pages/Device/DevicePending'));
const DhiEntryListing = lazy(() => import('../pages/Dhi/DhiEntryListing'));
const Profile = lazy(() => import('../pages/Profile'));

const coreRoutes = [
  {
    path: '/',
    title: 'home page',
    component: Home,
    allowedRoles: [],
  },
  {
    path: '/unloading',
    title: 'unloading',
    component: Unloading,
    allowedRoles: [],
  },
  {
    path: '/products',
    title: 'Product Page',
    component: ProductListing,
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Management',
      'Operator',
    ],
  },
  {
    path: 'unloading/gate-entries',
    title: 'vehicle-unloading-gate-entries',
    component: GateEntryListing,
    allowedRoles: ['Production Admin', 'Master Admin', 'Operator'],
  },
  {
    path: '/unloading/gate-entry',
    title: 'gate-entry-form',
    component: GateEntryForm,
    allowedRoles: ['Production Admin', 'Master Admin', 'Operator'],
  },
  {
    path: '/unloading/gate-entry/:id',
    title: 'edit-gate-entry-form',
    component: GateEntryForm,
    allowedRoles: ['Production Admin', 'Master Admin'],
  },
  {
    path: '/unloading/bill-entries',
    title: 'gate-entries',
    component: PurchaseBillEntries,
    allowedRoles: ['Production Admin', 'Master Admin', 'Operator'],
  },
  {
    path: '/unloading/bill-entries/:id',
    title: 'add-bill-entry',
    component: AddBillEntryForm,
    allowedRoles: ['Production Admin', 'Master Admin', 'Operator'],
  },
  {
    path: '/unloading/pd-approval',
    title: 'Purchased Department Approval',
    component: PDApprovalListing,
    allowedRoles: ['Production Admin', 'Master Admin', 'Purchase Department'],
  },
  {
    path: '/unloading/pd-approval/:id',
    title: 'Purchased Department Approval Form',
    component: PDApprovalForm,
    allowedRoles: ['Production Admin', 'Master Admin', 'Purchase Department'],
  },
  {
    path: '/unloading/concern',
    title: 'Concern Pending Listing',
    component: ConcernListing,
    allowedRoles: ['Production Admin', 'Master Admin'],
  },

  {
    path: '/unloading/concern/:id',
    title: 'Concern Form',
    component: PDApprovalForm,
    allowedRoles: ['Production Admin', 'Master Admin'],
  },
  {
    path: '/unloading/approval',
    title: 'Unload Approval',
    component: UnloadApprovalListing,
    allowedRoles: ['Production Admin', 'Master Admin'],
  },

  {
    path: '/unloading/approval/:id',
    title: 'Unload Approval Form',
    component: PDApprovalForm,
    allowedRoles: ['Production Admin', 'Master Admin'],
  },
  {
    path: '/unloading/master-entry',
    title: 'Complete Unloading All Steps',
    component: MasterUnloadListing,
    allowedRoles: MASTER_UNLOAD_ROLES,
  },
  {
    path: '/unloading/master-entry/:id',
    title: 'Complete Unloading All Steps Form',
    component: MasterUnloadForm,
    allowedRoles: MASTER_UNLOAD_ROLES,
  },
  {
    path: '/unloading/unload-completion',
    title: 'Unload completion',
    component: UnloadComplation,
    allowedRoles: ['Production Admin', 'Master Admin', 'Operator'],
  },
  {
    path: '/unloading/unload-completion/:id',
    title: 'Unload completion Form',
    component: UnloadComplationForm,
    allowedRoles: ['Production Admin', 'Master Admin', 'Operator'],
  },
  {
    path: '/lab-process',
    title: 'Lab Menu',
    component: LabMenu,
    allowedRoles: [
      'Lab In Charge',
      'Production Admin',
      'Master Admin',
      'Coordinator',
    ],
  },
  {
    path: '/lab-process/vehicle-loading',
    title: 'Lab entries',
    component: LoadingVehiclesListing,
    allowedRoles: ['Lab In Charge', 'Production Admin', 'Master Admin'],
  },
  {
    path: '/lab-process/vehicle-unloading',
    title: 'Lab entries',
    component: UnloadingVehicleListing,
    allowedRoles: ['Lab In Charge', 'Production Admin', 'Master Admin'],
  },
  {
    path: '/lab-process/:vehicleType/:id',
    title: 'Lab Check Stage one',
    component: LabProcess,
    allowedRoles: ['Lab In Charge', 'Production Admin', 'Master Admin'],
  },
  {
    path: '/lab-tests',
    title: 'All Lab Tests',
    component: LabTestingListing,
    allowedRoles: [
      'Lab In Charge',
      'Production Admin',
      'Master Admin',
      'Coordinator',
    ],
  },
  {
    path: '/lab-tests/:id',
    title: 'Lab test detail',
    component: SingleLabTest,
    allowedRoles: [
      'Lab In Charge',
      'Production Admin',
      'Master Admin',
      'Coordinator',
    ],
  },
  {
    path: '/unloading/exit',
    title: 'Unload Exit Listing',
    component: UnloadExitListing,
    allowedRoles: ['Production Admin', 'Master Admin', 'Operator'],
  },
  {
    path: '/unloading/exit/:id',
    title: 'Unload Exit Form',
    component: UnloadGateExitForm,
    allowedRoles: ['Production Admin', 'Master Admin', 'Operator'],
  },
  {
    path: '/unloading/vehicles',
    title: 'Unload Data',
    component: UnloadDataEntries,
    allowedRoles: ['Production Admin', 'Master Admin', 'Operator'],
  },
  {
    path: '/unloading/vehicles/:id',
    title: 'Unload Vehicle single Data',
    component: UnloadSingleData,
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Management',
      'Accountant Assistant',
      // Completed rows on Complete Unloading open here read-only, so whoever
      // can reach that listing has to be able to read the record.
      'Purchase Department',
    ],
  },
  {
    path: '/loading/do-an-order',
    title: 'Do An Order Entries',
    component: DoAnOrderEntries,
    allowedRoles: ['Production Admin', 'Master Admin', 'Coordinator'],
  },
  {
    path: '/loading/do-an-order/item',
    title: 'Do An Order',
    component: DoAnOrder,
    allowedRoles: ['Production Admin', 'Master Admin', 'Coordinator'],
  },
  {
    path: '/loading/do-an-order/item/:id',
    title: 'Edit Do An Order',
    component: DoAnOrder,
    allowedRoles: ['Production Admin', 'Master Admin'],
  },
  {
    path: '/loading/vehicles',
    title: 'All Vehicle Loading Data',
    component: VehicleLoadingLisitng,
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Operator',
      'Coordinator',
    ],
  },
  {
    path: '/loading/vehicles/:id',
    title: 'Load Vehicle single Data',
    component: LoadSingleData,
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Management',
      'Accountant',
      'Accountant Assistant',
      'Coordinator',
    ],
  },

  {
    path: '/loading',
    title: 'loading',
    component: VehicleLoading,
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Coordinator',
      'Operator',
      'Accountant',
    ],
  },
  {
    path: '/loading/pending-approval',
    title: 'Loading Material Approval',
    component: ApproveMaterialLoadListing,
    allowedRoles: ['Production Admin', 'Master Admin'],
  },
  {
    path: '/loading/master-entry',
    title: 'Complete Loading All Steps',
    component: MasterLoadListing,
    allowedRoles: ['Master Admin', 'Coordinator'],
  },
  {
    path: '/loading/master-entry/:id',
    title: 'Complete Loading All Steps Form',
    component: MasterLoadForm,
    allowedRoles: ['Master Admin', 'Coordinator'],
  },
  {
    path: '/loading/pending-approval/:id',
    title: 'Loading Approval Form',
    component: ApproveForm,
    allowedRoles: ['Production Admin', 'Master Admin'],
  },
  {
    path: '/loading/bill-list',
    title: 'Sale Order List',
    component: BillList,
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Operator',
      'Coordinator',
    ],
  },
  {
    path: '/loading/bill-list/:id',
    title: 'Add Bill Detail',
    component: AddBillingDetail,
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Operator',
      'Coordinator',
    ],
  },
  {
    path: '/purchase-dept/bill-list',
    title: 'Bill planning List',
    component: BillList,
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Purchase Department',
      'Bill Planner',
    ],
  },
  {
    path: '/purchase-dept/bill-list/:id',
    title: 'Add Bill Detail',
    component: AddBillingDetail,
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Purchase Department',
      'Bill Planner',
    ],
  },
  {
    path: '/loading/completion',
    title: 'Loading Completion ',
    component: LoadingCompletion,
    allowedRoles: ['Production Admin', 'Master Admin', 'Operator'],
  },
  {
    path: '/loading/completion/:id',
    title: 'Loading Completion Form',
    component: CompletionForm,
    allowedRoles: ['Production Admin', 'Master Admin', 'Operator'],
  },
  {
    path: '/loading/customers',
    title: 'Vehicle Loading Customers',
    component: CustomerDetailListing,
    allowedRoles: ['Production Admin', 'Master Admin', 'Operator'],
  },
  {
    path: '/loading/customers/:id',
    title: 'Vehicle Loading Customers',
    component: CustomerDetailForm,
    allowedRoles: ['Production Admin', 'Master Admin', 'Operator'],
  },
  {
    path: '/loading/exit',
    title: 'Vehicle Loading Exit Procedure',
    component: GateExitListing,
    allowedRoles: ['Production Admin', 'Master Admin', 'Operator'],
  },
  {
    path: '/loading/exit/:id',
    title: 'Exit Pass',
    component: ExitPassForm,
    allowedRoles: ['Production Admin', 'Master Admin', 'Operator'],
  },
  {
    path: '/approve',
    title: 'Main Approval',
    component: ApproveMenu,
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Management',
      'Accountant Assistant',
    ],
  },
  {
    path: '/approve/card-unload',
    title: 'Card Unload',
    allowedRoles: ['Production Admin', 'Master Admin', 'Management'],
    component: UnloadCardMenu,
  },
  {
    path: '/approve/card-load',
    title: 'Card Load',
    allowedRoles: ['Production Admin', 'Master Admin', 'Management'],
    component: LoadCardMenu,
  },
  {
    path: '/purchase-dept',
    title: 'Purchase Department Menu',
    component: PurchaseDeptMenu,
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Management',
      'Purchase Department',
      'Coordinator',
      'Operator',
      'Accountant Assistant',
      'Bill Planner',
    ],
  },
  {
    path: '/unloading/upcoming',
    title: 'Upcoming Unload List',
    component: UpcomingUnload,
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Management',
      'Purchase Department',
      'Coordinator',
      'Operator',
      'Accountant Assistant',
    ],
  },
  {
    path: '/unloading/upcoming/add',
    title: 'Add Upcoming Unload',
    component: AddUpcomingUnload,
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Management',
      'Purchase Department',
      'Coordinator',
      'Operator',
      'Accountant Assistant',
    ],
  },
  {
    path: '/unloading/upcoming/edit/:id',
    title: 'Edit Upcoming Unload',
    component: AddUpcomingUnload,
    allowedRoles: ['Production Admin', 'Master Admin'],
  },
  {
    path: '/upcoming/unload/transports',
    title: 'Transport Form',
    component: TransportForm,
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Management',
      'Purchase Department',
      'Coordinator',
      'Operator',
    ],
  },

  {
    path: 'unloading/upcoming/:id',
    title: 'Unloading Upcoming Detail',
    component: UpcomingUnloadDetail,
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Management',
      'Purchase Department',
      'Accountant',
      'Coordinator',
      'Operator',
      'Accountant Assistant',
    ],
  },
  {
    path: '/purchase-dept/credit-debit-note',
    title: 'Credit/Debit Note',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Accountant',
      'Purchase Department',
      'Accountant Assistant',
    ],
    component: UnloadReport,
  },
  {
    path: '/loading/direct-sale',
    title: 'Direct Sale',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Coordinator',
      'Management',
    ],
    component: DoAnOrderDirectSale,
  },
  {
    path: '/bvn-dept',
    title: 'Bhavnagar Deparment',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Accountant',
      // 'Purchase Department',
      'Accountant Assistant',
      'Coordinator',
      'Bill Planner',
    ],
    component: BvnMenu,
  },
  {
    path: '/bvn-dept/sale',
    title: 'All Sale',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Accountant',
      'Accountant Assistant',
    ],
    component: AllSale,
  },
  {
    path: '/bvn-dept/purchase',
    title: 'All Purchase',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Accountant',
      'Accountant Assistant',
    ],
    component: AllPurchase,
  },
  {
    path: '/bvn-dept/unload-report',
    title: 'All Purchase',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Accountant',
      'Purchase Department',
      'Accountant Assistant',
    ],
    component: UnloadReport,
  },
  {
    path: '/bvn-dept/to-generate',
    title: 'To Generate',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Accountant',
      'Accountant Assistant',
    ],
    component: ToGenerate,
  },
  {
    path: '/bvn-dept/bmr-bills',
    title: 'Bmr Bills',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Accountant',
      'Accountant Assistant',
    ],
    component: BmrBillListing,
  },
  {
    path: '/bvn-dept/notifications',
    title: 'Notifications',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Accountant',
      'Purchase Department',
      'Accountant Assistant',
      'Coordinator',
      'Bill Planner',
    ],
    component: BvnNotifications,
  },

  {
    path: '/lab-process/samples',
    title: 'Samples',
    allowedRoles: ['Production Admin', 'Master Admin', 'Lab In Charge'],
    component: LabSamples,
  },
  {
    path: '/lab-process/samples/add',
    title: 'Add Samples',
    allowedRoles: ['Production Admin', 'Master Admin', 'Lab In Charge'],
    component: LabSampleForm,
  },
  {
    path: '/sample-menu',
    title: 'Sample Menu',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Lab In Charge',
      'Management',
      'Coordinator',
    ],
    component: SampleMenu,
  },
  {
    path: '/sample-menu/samples',
    title: 'Samples Listing',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Lab In Charge',
      'Management',
      'Coordinator',
    ],
    component: SampleListing,
  },
  {
    path: '/approve/samples',
    title: 'Sample Listing',
    allowedRoles: ['Production Admin', 'Master Admin', 'Management'],
    component: SampleListing,
  },
  {
    path: '/samples/add',
    title: 'Samples Add Form',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Lab In Charge',
      'Management',
    ],
    component: SampleForm,
  },
  {
    path: '/samples/:id',
    title: 'Update Sample',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Lab In Charge',
      'Management',
    ],
    component: SampleForm,
  },
  {
    path: '/samples/:id/detail',
    title: 'Sample Detail',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Lab In Charge',
      'Management',
      'Coordinator',
    ],
    component: SampleDetail,
  },
  {
    path: '/sample-menu/couriers',
    title: 'Courier Listing',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Lab In Charge',
      'Management',
      'Coordinator',
    ],
    component: CourierListing,
  },
  {
    path: '/couriers/add',
    title: 'Courier Add form',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Coordinator',
      'Management',
      'Coordinator',
    ],
    component: CourierAddForm,
  },
  {
    path: '/couriers/:id',
    title: 'Courier Add form',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Lab In Charge',
      'Management',
      'Coordinator',
    ],
    component: CourierUpdateForm,
  },
  {
    path: '/couriers/:id/detail',
    title: 'Courier Detail',
    allowedRoles: [
      'Production Admin',
      'Master Admin',
      'Lab In Charge',
      'Coordinator',
      'Management',
      'Coordinator',
    ],
    component: CourierDetail,
  },
  {
    path: '/users',
    title: 'Users',
    allowedRoles: ['Production Admin', 'Master Admin'],
    component: UserListing,
  },
  {
    path: '/transporters',
    title: 'Transporters',
    allowedRoles: ['Production Admin', 'Master Admin'],
    component: TransporterListing,
  },
  {
    path: '/dhi-entries',
    title: 'DHI Entries',
    allowedRoles: LIST_EDIT_DELETE_ROLES,
    component: DhiEntryListing,
  },
  {
    path: '/vehicle-numbers',
    title: 'Vehicle Numbers',
    allowedRoles: ['Production Admin', 'Master Admin'],
    component: VehicleNumberListing,
  },
  {
    path: '/approve/report',
    title: 'Report',
    allowedRoles: ['Production Admin', 'Master Admin', 'Accountant Assistant'],
    component: Report,
  },
  {
    path: '/device-pending',
    title: 'Device Pending',
    allowedRoles: [],
    component: DevicePending,
  },
  {
    path: '/device-approval',
    title: 'Device Approval',
    // Device approval is restricted to Master Admin
    allowedRoles: ['Master Admin'],
    component: DeviceApproval,
  },
  {
    path: '/profile',
    title: 'Profile',
    allowedRoles: [],
    component: Profile,
  },
  {
    path: '/profile/:userId',
    title: 'User Profile',
    allowedRoles: ['Production Admin', 'Master Admin'],
    component: Profile,
  },
];

const routes = [...coreRoutes];
export default routes;
